import React, { FC, useEffect } from 'react';

import SectionWrapper from '../../components/SectionWrapper';
import TestComponent from '../../components/TestComponent';
import styles from './testScreen.module.sass';

const TestScreen: FC = () => {
  useEffect(() => {}, []);

  return (
    <SectionWrapper classes={`${styles.root}`}>
      <TestComponent />
    </SectionWrapper>
  );
};

export default TestScreen;
